import React from 'react';
import PropTypes from 'prop-types';

class TeamPlayer extends React.Component {

  static propTypes = {
    details: PropTypes.shape({
      position: PropTypes.string,
      name: PropTypes.string,
      salary: PropTypes.number,
    })
  }

  formatName = (name) => {
    return name.replace(/\s/g, '')
      .replace(/-/g, '')
      .replace(/'/g, '')
      .replace(/\./g, '')
      .replace(/’/g, '')
      .toLowerCase();
  }

  showSalary(salary) {
    if (salary > 0) {
      return <p className="finished__salary">${salary} million</p>;
    } return <p className="finished__salary">Draft pick</p>;
  }

  render() {
    return (
      <div className="player finished__player">
        <span className="player__pos">{this.props.details.position}</span>
        <img src={`./images/${this.formatName(this.props.details.name)}.jpg`} alt={this.props.details.name} />
        <h5>{this.props.details.name}</h5>
        <div className="player__details">
          {this.showSalary(this.props.details.salary)}
        </div>
      </div>
    )
  }
}

export default TeamPlayer;